/**
 * Inicializa a troca de variantes nos cards de produto do EC Video Showcase.
 * Procura por [data-ec-video-showcase-section-id] e inicializa os cards dentro da seção.
 */
(function () {
  function initSection(sectionRoot) {
    const sectionId = sectionRoot.dataset.ecVideoShowcaseSectionId;
    if (!sectionId) return;

    const cards = sectionRoot.querySelectorAll('[data-video-showcase-product-card]');

    cards.forEach((card) => {
      const variantsScript = card.querySelector('[data-product-variants]');
      if (!variantsScript) return;

      let variants = [];
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (error) {
        return;
      }

      if (!Array.isArray(variants) || variants.length === 0) return;

      const variantInput = card.querySelector('[data-variant-id-input]');
      const productImage = card.querySelector('.ec-video-showcase__product-card-image-variant');
      const productLinks = card.querySelectorAll('[data-product-link]');
      const currentPrice = card.querySelector('[data-price-current]');
      const comparePrice = card.querySelector('[data-price-compare]');
      const addToCart = card.querySelector('[data-add-to-cart]');
      const addToCartLabel = card.querySelector('[data-add-to-cart-label]');
      const selectedValueLabels = card.querySelectorAll('[data-option-selected-value]');
      const optionButtons = card.querySelectorAll('[data-option-index][data-option-value]');

      let selectedOptions = [];
      try {
        selectedOptions = JSON.parse(card.dataset.selectedOptions || '[]');
      } catch (error) {
        selectedOptions = [];
      }

      const findVariantByOptions = (options) => {
        return variants.find((variant) => {
          if (!Array.isArray(variant.options) || variant.options.length !== options.length) return false;
          return variant.options.every((value, index) => String(value).trim() === String(options[index]).trim());
        });
      };

      const updateButtonsState = () => {
        optionButtons.forEach((button) => {
          const optionIndex = Number(button.dataset.optionIndex);
          const optionValue = button.dataset.optionValue;
          const isActive = selectedOptions[optionIndex] === optionValue;
          const nextSelection = [...selectedOptions];
          nextSelection[optionIndex] = optionValue;
          const hasMatchingVariant = Boolean(findVariantByOptions(nextSelection));

          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          button.disabled = !hasMatchingVariant;
        });
      };

      const applyVariant = (variant) => {
        if (!variant) return;

        if (variantInput) {
          variantInput.value = variant.id;
          variantInput.disabled = !variant.available;
        }

        if (productImage) {
          const imageToUse = variant.featured_image || card.dataset.defaultImage;
          const imageAltToUse = variant.featured_image_alt || card.dataset.defaultImageAlt || productImage.alt || '';

          if (imageToUse) {
            productImage.src = imageToUse;
            productImage.alt = imageAltToUse;
          }
        }

        productLinks.forEach((link) => {
          const productUrl = card.dataset.productUrl;
          if (!productUrl) return;
          link.href = `${productUrl}?variant=${variant.id}`;
        });

        if (currentPrice && variant.price) {
          currentPrice.textContent = variant.price;
        }

        if (comparePrice) {
          const hasComparePrice =
            typeof variant.compare_at_price === 'string' &&
            variant.compare_at_price.trim() !== '' &&
            variant.compare_at_price !== variant.price;

          comparePrice.textContent = hasComparePrice ? variant.compare_at_price : '';
          comparePrice.classList.toggle('hidden', !hasComparePrice);
        }

        if (addToCart) {
          addToCart.disabled = !variant.available;
        }

        if (addToCartLabel) {
          addToCartLabel.textContent = variant.available ? 'Adicionar ao carrinho' : 'Indisponível';
        }

        card.dataset.selectedOptions = JSON.stringify(Array.isArray(variant.options) ? variant.options : []);
      };

      let activeVariant = findVariantByOptions(selectedOptions);
      if (!activeVariant && variantInput) {
        activeVariant = variants.find((variant) => String(variant.id) === String(variantInput.value));
      }
      if (!activeVariant) activeVariant = variants[0];
      if (!activeVariant) return;

      selectedOptions = Array.isArray(activeVariant.options) ? [...activeVariant.options] : selectedOptions;

      selectedValueLabels.forEach((label, index) => {
        if (selectedOptions[index]) label.textContent = selectedOptions[index];
      });

      updateButtonsState();
      applyVariant(activeVariant);

      optionButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const optionIndex = Number(button.dataset.optionIndex);
          const optionValue = button.dataset.optionValue;
          const nextSelection = [...selectedOptions];
          nextSelection[optionIndex] = optionValue;
          const matchedVariant = findVariantByOptions(nextSelection);

          if (!matchedVariant) return;

          selectedOptions = nextSelection;
          selectedValueLabels.forEach((label, index) => {
            if (selectedOptions[index]) label.textContent = selectedOptions[index];
          });

          updateButtonsState();
          applyVariant(matchedVariant);
        });
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-ec-video-showcase-section-id]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const sectionRoot = event.target.querySelector('[data-ec-video-showcase-section-id]');
    if (sectionRoot) initSection(sectionRoot);
  });
})();
